<template>
  <div class="trasporto">
    <div class="col-22 offset-1">

      <div class="riga row row-custom no-padding">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.numConferma') }}</div>
          <div class="value-big col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding">{{ conf.numConf }}</div>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.dataConsegna') }}</div>
          <div class="value col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding">{{ conf.datConsDa + ' - ' + conf.datConsA }}</div>
        </div>
      </div>

      <div class="riga row row-custom no-padding">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.numDdt') }}</div>
          <el-input
            v-model="formTrasporto.numDdt" :maxlength="8"
            class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"
            @blur="formTrasporto.numDdt = formTrasporto.numDdt.trim()"
          >
          </el-input>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding" v-if="(formTrasporto.ifFir === '1')">
          <div class="my-label col-10">{{ $t('trasporto.FIR') }}</div>
          <el-input
            v-model="formTrasporto.fir_1" :maxlength="5"
            class="custom-input col-xl-5 col-lg-2 col-md-3 col-sm-4 col-4 offset-1 no-padding"
            style="padding-right: 2px !important"
            @input="formTrasporto.fir_1 = formTrasporto.fir_1.replace(/[^A-Za-z0-9]/g, '').toUpperCase()"
          />
          <el-input
            v-model="formTrasporto.fir_2" :maxlength="6"
            class="custom-input col-xl-5 col-lg-3 col-md-3 col-sm-4 col-4 no-padding"
            @input="formTrasporto.fir_2 = formTrasporto.fir_2.replace(/\D/g, '')"
          />
          <el-input
            v-model="formTrasporto.fir_3" :maxlength="2"
            class="custom-input col-xl-2 col-lg-1 col-md-2 col-sm-2 col-3 no-padding"
            style="padding-left: 2px !important"
            @input="formTrasporto.fir_3 = formTrasporto.fir_3.replace(/[^A-Za-z0-9]/g, '').toUpperCase()"
          />
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding" v-if="(ordNave.length > 0)">
          <div class="my-label col-10">{{ $t('trasporto.ordNave') }}</div>
          <el-select v-model="formTrasporto.ordNave" placeholder=""
                     class="custom-select-el col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"
                     value-key="numOrdNave">
            <el-option
              v-for="item in ordNave"
              :key="item.numOrdNave"
              :label="item.numOrdNave"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="riga row row-custom no-padding" v-if="(conf.modoTrasp === '2')">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.letVettura') }}</div>
          <el-input v-model="formTrasporto.letVettura" :maxlength="5" @blur="formTrasporto.letVettura = formTrasporto.letVettura.trim()"
                    class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.dataLVettura') }}</div>
          <div class="value col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding">
            <el-date-picker v-model="formTrasporto.dataLVettura" class="dt-picker custom-date-picker"
                            type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy">
            </el-date-picker>
          </div>
        </div>
      </div>

      <div class="riga row row-custom no-padding" v-if="(conf.modoTrasp === '3')">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.targaMotrice') }}</div>
          <el-input v-model="formTrasporto.targaMotrice" :maxlength="10"
                    @input="formTrasporto.targaMotrice = formTrasporto.targaMotrice.replace(/[^0-9A-Za-záàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ]/g, '').toUpperCase()"
                    @blur="formTrasporto.targaMotrice = formTrasporto.targaMotrice.replace(/[^0-9A-Za-záàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ]/g, '').toUpperCase(); getIntestatario()"
                    class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.targaRimorchio') }}</div>
          <el-input v-model="formTrasporto.targaRimorchio" :maxlength="10"
                    @input="formTrasporto.targaRimorchio = formTrasporto.targaRimorchio.replace(/[^0-9A-Za-záàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ]/g, '').toUpperCase()"
                    @blur="formTrasporto.targaRimorchio = formTrasporto.targaRimorchio.replace(/[^0-9A-Za-záàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ]/g, '').toUpperCase()"
                    class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
        </div>
      </div>
      <div class="riga row row-custom no-padding" v-if="(conf.modoTrasp === '3' && intestatario)">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.intMezzo') }}</div>
          <div class="value-intestatario col-13 offset-1 no-padding">{{ intestatario }}</div>
        </div>
      </div>
      <div class="riga row row-custom no-padding" v-if="(conf.modoTrasp === '2')">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.numVagone') }}</div>
          <el-input v-model="formTrasporto.numVagone" :maxlength="12" @blur="formTrasporto.numVagone = formTrasporto.numVagone.trim()"
                    class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
        </div>
      </div>

      <div class="riga row row-custom no-padding">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.dataSpedizione') + ' (*)' }}</div>
          <div class="col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding">
            <el-date-picker v-model="formTrasporto.dataSpedizione" class="dt-picker custom-date-picker"
                            :picker-options="{
                              firstDayOfWeek: 1
                            }"
                            type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy">
            </el-date-picker>
          </div>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding" v-if="(conf.modoTrasp !== '2')">
          <div class="my-label col-10">{{ $t('trasporto.dataArrivo') + ' (*)' }}</div>
          <div class="col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding" v-if="formTrasporto.ROT_SLOT_RULES !== 'Y'">
            <el-date-picker v-model="formTrasporto.dataArrivo" class="dt-picker custom-date-picker"
                            :picker-options="{
                              firstDayOfWeek: 1
                            }"
                            type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy">
            </el-date-picker>
          </div>
          <div class="col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding row" v-else>
            <el-date-picker v-model="formTrasporto.dataArrivo" class="dt-picker custom-date-picker custom-date-picker-half col-12"
                            :picker-options="{
                              firstDayOfWeek: 1
                            }"
                            type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy"
                            @change="changeDataArrivo">
            </el-date-picker>
            <el-select v-model="formTrasporto.slot"
                    class="custom-select-el custom-select-half col-12 no-padding" placeholder=""
                    :disabled="!formTrasporto.dataArrivo" clearable>
              <el-option
                v-for="item in slots"
                :key="item.cod"
                :label="item.des"
                :value="item.cod"
                :disabled="parseInt(item.disp) <= 0">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="riga row row-custom no-padding">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.localita') + ' (*)' }}</div>
          <el-select v-model="formTrasporto.loc" class="custom-select-el col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"
                     filterable :filter-method="dataFilterLocalita"
                     value-key="codLoca" @change="changeLocalita" placeholder="">
            <el-option
              v-for="item in localitaFiltered"
              :key="item.codLoca"
              :label="item.desLoca"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.subFor') }}</div>
          <el-select v-model="formTrasporto.subFor" filterable :filter-method="dataFilterSubFor"
                     class="custom-select-el col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding" placeholder=""
                     value-key="codSubfor" @change="changeSubfor" :disabled="subForIsDisabled">
            <el-option
              v-for="item in subFornitoriFiltered"
              :key="item.codSubfor"
              :label="item.desSubfor"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </div>

      <!-- DATI TRASPORTATORE: se Spagna mostra dati aggiuntivi -->
      <div class="riga row row-custom no-padding" v-if="(this.form.country !== '3')">
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.spedizioniere') + (ifSpedizObblig ? ' (*)' : '') }}</div>
          <el-input v-model="formTrasporto.spedizioniere.desSpediz" :maxlength="30" @blur="formTrasporto.spedizioniere.desSpediz = formTrasporto.spedizioniere.desSpediz.trim()"
                    class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding" v-if="formTrasporto.spedizTxt === '1'" />
          <el-select v-model="formTrasporto.spedizioniere" placeholder="" filterable :filter-method="dataFilterSpediz"
                     class="custom-select-el col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"
                     :value-key="(formTrasporto.UNI_TRASP_ROT === 'Y') ? 'codTRS' : 'codSpediz'" :disabled="spedizIsDisabled" v-else>
            <el-option
              v-for="item in spedizionieriFiltered"
              :key="(formTrasporto.UNI_TRASP_ROT === 'Y') ? item.codTRS : item.codSpediz"
              :label="item.desSpediz"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-xl-11 col-24 row row-custom no-padding">
          <div class="my-label col-10">{{ $t('trasporto.nomeAutista')}}</div>
          <el-input v-model="formTrasporto.nomeAutista" :maxlength="25" @blur="formTrasporto.nomeAutista = formTrasporto.nomeAutista.trim()"
                    class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
        </div>
      </div>
      <!-- v-else Spagna -->
      <div class="col-24 no-padding dati-trasportatore" v-else>
        <div class="div-titolo offset-xl-2 col-xl-20 offset-md-5 col-md-14 offset-sm-3 col-18 offset-2 col-20 no-padding">
          <div class="titolo col-24">{{ $t('trasporto.datiTrasportatore') }}</div>
        </div>

        <div class="riga row row-custom no-padding">
          <div class="col-xl-11 col-24 row row-custom no-padding" v-if="ifSpedizObblig">
            <div class="my-label col-10">{{ $t('trasporto.ragioneSociale') + ' (*)' }}</div>
            <el-select v-model="formTrasporto.spedizioniere" placeholder="" filterable :filter-method="dataFilterSpediz"
                      class="custom-select-el col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"
                      :value-key="(formTrasporto.UNI_TRASP_ROT === 'Y') ? 'codTRS' : 'codSpediz'" :disabled="spedizIsDisabled">
              <el-option
                v-for="item in spedizionieriFiltered"
                :key="(formTrasporto.UNI_TRASP_ROT === 'Y') ? item.codTRS : item.codSpediz"
                :label="item.desSpediz"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-xl-11 col-24 row row-custom no-padding" v-else>
            <div class="my-label col-10">{{ $t('trasporto.ragioneSociale') + ' (*)' }}</div>
            <el-input
              v-model="formTrasporto.ragSocTrasp" :maxlength="30" @blur="formTrasporto.ragSocTrasp = formTrasporto.ragSocTrasp.trim()"
              class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"
            />
          </div>
        </div>

        <div class="riga row row-custom no-padding">
          <div class="col-xl-11 col-24 row row-custom no-padding">
            <div class="my-label col-10">{{ $t('trasporto.indirizzo') + ' (*)' }}</div>
            <el-input v-model="formTrasporto.indirTrasp" :maxlength="30" @blur="formTrasporto.indirTrasp = formTrasporto.indirTrasp.trim()"
                      class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
          </div>
          <div class="col-xl-11 col-24 row row-custom no-padding">
            <div class="my-label col-10">{{ $t('trasporto.localita') + ' (*)' }}</div>
            <el-input v-model="formTrasporto.localTrasp" :maxlength="30" @blur="formTrasporto.localTrasp = formTrasporto.localTrasp.trim()"
                      class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
          </div>
        </div>

        <div class="riga row row-custom no-padding">
          <div class="col-xl-11 col-24 row row-custom no-padding">
            <div class="my-label col-10">{{ $t('trasporto.cap') + ' (*)' }}</div>
            <el-input v-model="formTrasporto.capTrasp" :maxlength="5" @blur="formTrasporto.capTrasp = formTrasporto.capTrasp.trim()"
                      class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
          </div>
          <div class="col-xl-11 col-24 row row-custom no-padding">
            <div class="my-label col-10">{{ $t('trasporto.partitaIva') + ' (*)' }}</div>
            <el-input v-model="formTrasporto.paIvaTrasp" :maxlength="15" @blur="formTrasporto.paIvaTrasp = formTrasporto.paIvaTrasp.trim()"
                      class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
          </div>
        </div>

        <div class="riga row row-custom no-padding">
          <div class="col-xl-11 col-24 row row-custom no-padding">
            <div class="my-label col-10">{{ $t('trasporto.nomeAutista') + ' (*)' }}</div>
            <el-input v-model="formTrasporto.nomeAutista" :maxlength="25" @blur="formTrasporto.nomeAutista = formTrasporto.nomeAutista.trim()"
                      class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
          </div>
          <div class="col-xl-11 col-24 row row-custom no-padding">
            <div class="my-label col-10">{{ $t('trasporto.numeroPatente') + ' (*)' }}</div>
            <el-input v-model="formTrasporto.nPatente" :maxlength="20" @blur="formTrasporto.nPatente = formTrasporto.nPatente.trim()"
                      class="custom-input col-xl-12 col-lg-6 col-md-8 col-sm-10 col-11 offset-1 no-padding"></el-input>
          </div>
        </div>
      </div>

      <div class="button col-22 no-padding">
        <el-button type="primary" class="custom-button" @click="avanti" :disabled="!canGoNext" :loading="loadingButton">{{ $t('trasporto.avanti').toUpperCase() }}</el-button>
      </div>

    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Trasporto',
    props: ['conf', 'buono', 'saved'],
    i18n: {
      messages: {
        it_IT: {
          trasporto: {
            numConferma: 'Nr. Conferma',
            dataConsegna: 'Data Consegna',
            numDdt: 'Numero DDT',
            ordNave: 'Ordine Nave',
            localita: 'Località',
            subFor: 'SubFornitore',
            spedizioniere: 'Spedizioniere',
            nomeAutista: 'Nome Autista',
            targaMotrice: 'Targa Motrice',
            targaRimorchio: 'Targa Rimorchio',
            numVagone: 'Numero Vagone',
            dataSpedizione: 'Data Spedizione',
            dataArrivo: 'Data Arrivo',
            avanti: 'Avanti',
            letVettura: 'Lettera Vettura',
            dataLVettura: 'Data Lettera Vettura',
            datiTrasportatore: 'Dati Trasportatore',
            ragioneSociale: 'Ragione Sociale',
            indirizzo: 'Indirizzo',
            cap: 'CAP',
            partitaIva: 'Partita IVA',
            numeroPatente: 'N. Patente Autista',
            FIR: 'FIR',
            intMezzo: 'Intestatario mezzo',
            attenzione: 'Attenzione',
            annulla: 'Annulla',
            ok: 'Ok',
            correggi: 'Correggi',
            prosegui: 'Prosegui'
          }
        },
        fr_FR: {
          trasporto: {
            numConferma: 'Nr. Commande',
            dataConsegna: 'Date Commande',
            numDdt: 'Numéro Bon de Livraison',
            ordNave: 'Commande Navire',
            localita: 'Provenance',
            subFor: 'Sous Traitant',
            spedizioniere: 'Transporteur',
            nomeAutista: 'Nom du Chauffeur',
            targaMotrice: 'Immatric. Tracteur',
            targaRimorchio: 'Immatric. Remorque',
            numVagone: 'Numéro Wagon',
            dataSpedizione: 'Date d\'Expedition',
            dataArrivo: 'Date arrivée',
            avanti: 'Suivant',
            letVettura: 'Lettre de voiture',
            dataLVettura: 'Lettre de voiture date',
            datiTrasportatore: 'Données du Convoyeur',
            ragioneSociale: 'Nom de l\'Entreprise',
            indirizzo: 'Adresse',
            cap: 'CAP',
            partitaIva: 'Numéro de TVA',
            numeroPatente: 'N. Permis de Conduire',
            FIR: 'FIR',
            intMezzo: 'Propr. du véhicule',
            attenzione: 'Avertissement',
            annulla: 'Annuler',
            ok: 'Ok',
            correggi: 'Corriger',
            prosegui: 'Continuer'
          }
        },
        es_ES: {
          trasporto: {
            numConferma: 'Nr. de Pedido',
            dataConsegna: 'Dìa de Entrega',
            numDdt: 'Numero DDT',
            ordNave: 'Contrato Barco',
            localita: 'Localidad',
            subFor: 'Subproveedor',
            spedizioniere: 'Transpostista',
            nomeAutista: 'Nombre Conductor',
            targaMotrice: 'Matricula Cabeza',
            targaRimorchio: 'Matricula Remolque',
            numVagone: 'Número de vagón',
            dataSpedizione: 'Día de salida',
            dataArrivo: 'Día llegada',
            avanti: 'Adelante',
            letVettura: 'Hoja de ruta',
            dataLVettura: 'Fecha Hoja de ruta',
            datiTrasportatore: 'Datos del Transportista',
            ragioneSociale: 'Empresa Transporte',
            indirizzo: 'Dirección',
            cap: 'Código Postal',
            partitaIva: 'NIF/CIF',
            numeroPatente: 'N. Carnet Conducir',
            FIR: 'FIR',
            intMezzo: 'Titular del vehículo',
            attenzione: 'Precaución',
            annulla: 'Cancelar',
            ok: 'Ok',
            correggi: 'Corrige',
            prosegui: 'Continuar'
          }
        },
        de_DE: {
          trasporto: {
            numConferma: 'Vertrag',
            dataConsegna: 'Lieferzeitraum',
            numDdt: 'Lieferschein Nr.',
            ordNave: 'Bestellen Schiff',
            localita: 'Herkunftsort',
            subFor: 'Subunternehmer',
            spedizioniere: 'Spediteur',
            nomeAutista: 'Fahrer',
            targaMotrice: 'Kennzeichen LKW',
            targaRimorchio: 'Kennzeichen Auflieger',
            numVagone: 'Waggonnummer',
            dataSpedizione: 'Versanddatum',
            dataArrivo: 'Ankunftsdatum',
            avanti: 'Weiter',
            letVettura: 'Frachtbrief',
            dataLVettura: 'Frachtfbriefsdatum',
            datiTrasportatore: 'Spediteurdaten',
            ragioneSociale: 'Firmenname',
            indirizzo: 'Adresse',
            cap: 'Postleitzahl',
            partitaIva: 'Umsatzsteuer-Id.',
            numeroPatente: 'Führerscheinnummer',
            FIR: 'FIR',
            intMezzo: 'Halter',
            attenzione: 'Achtung',
            annulla: 'Stornieren',
            ok: 'Ok',
            correggi: 'Korrigieren',
            prosegui: 'Weiter'
          }
        },
        en_GB: {
          trasporto: {
            numConferma: 'Confirm. Nr.',
            dataConsegna: 'Delivery Date',
            numDdt: 'DDT Number',
            ordNave: 'Order Ship',
            localita: 'Place',
            subFor: 'SubContractor',
            spedizioniere: 'Forwarder',
            nomeAutista: 'Driver Name',
            targaMotrice: 'Driving plate',
            targaRimorchio: 'Trailer plate',
            numVagone: 'Wagon Number',
            dataSpedizione: 'Shipping Date',
            dataArrivo: 'Arrival Date',
            avanti: 'Next',
            letVettura: 'Car Letter',
            dataLVettura: 'Car Letter Date',
            datiTrasportatore: 'Transport company data',
            ragioneSociale: 'Business Name',
            indirizzo: 'Address',
            cap: 'Postal Code',
            partitaIva: 'VAT number',
            numeroPatente: 'Driver\'s License N.',
            FIR: 'FIR',
            intMezzo: 'Vehicle owner',
            attenzione: 'Caution',
            annulla: 'Cancel',
            ok: 'Ok',
            correggi: 'Correct',
            prosegui: 'Continue'
          }
        }
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        localita: [],
        localitaFiltered: [],
        subFornitori: [],
        subFornitoriFiltered: [],
        spedizionieri: [],
        spedizionieriFiltered: [],
        ordNave: [],
        formTrasporto: {
          numDdt: '',
          letVettura: '',
          dataLVettura: '',
          ordNave: {},
          loc: {},
          subFor: {},
          spedizioniere: {},
          nomeAutista: '',
          targaMotrice: '',
          targaRimorchio: '',
          numVagone: '',
          dataSpedizione: '',
          dataArrivo: '',
          ragSocTrasp: '',
          indirTrasp: '',
          capTrasp: '',
          localTrasp: '',
          paIvaTrasp: '',
          nPatente: '',
          fir_1: '',
          fir_2: '',
          fir_3: '',
          ifFir: '',
          spedizTxt: '',
          ifRifiuto: '',
          slot: ''
        },
        form: {
          stab: {}
        },
        ifSpedizObblig: false,
        loadingButton: false,
        intestatario: '',
        slots: []
      }
    },
    mounted: function () {
      this.init()
    },
    activated: function () {
      this.$set(this, 'loadingButton', false)
      this.$set(this, 'intestatario', '')
      this.init()
    },
    watch: {
      saved: function (newVal, oldVal) {
        this.$set(this, 'formTrasporto', JSON.parse(JSON.stringify(newVal)))
        if (this.formTrasporto.ROT_SLOT_RULES === 'Y' && this.formTrasporto.dataArrivo) {
          this.getSlots()
        }
        if (!this._inactive) {
          if (Object.keys(this.saved).length > 0) {
            if (this.formTrasporto.targaMotrice) {
              this.getIntestatario()
            }
            this.getLocalita()
            this.getOrdNave()
            this.getSpedizionieri()
          }
        }
      },
      'formTrasporto.targaMotrice': function (newVal, oldVal) {
        if (newVal !== undefined) {
          newVal = newVal.toUpperCase()
          this.$set(this.formTrasporto, 'targaMotrice', newVal)
          // let regex = new RegExp('^[A-Z0-9][A-Z0-9 ]{0,}$')
          let regex = new RegExp('^[0-9A-ZÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ]{0,}$')
          if (!regex.test(newVal) && newVal !== '') {
            this.$set(this.formTrasporto, 'targaMotrice', oldVal)
          }
        }
      },
      'formTrasporto.targaRimorchio': function (newVal, oldVal) {
        if (newVal !== undefined) {
          newVal = newVal.toUpperCase()
          this.$set(this.formTrasporto, 'targaRimorchio', newVal)
          // let regex = new RegExp('^[A-Z0-9][A-Z0-9 ]{0,}$')
          let regex = new RegExp('^[0-9A-ZÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ]{0,}$')
          if (!regex.test(newVal) && newVal !== '') {
            this.$set(this.formTrasporto, 'targaRimorchio', oldVal)
          }
        }
      }
    },
    computed: {
      subForIsDisabled: function () {
        if (typeof this.formTrasporto === 'object' && !this._inactive) {
          return !((this.formTrasporto.loc.codLoca) && (this.subFornitori.length > 0))
        }
      },
      spedizIsDisabled: function () {
        if (typeof this.formTrasporto === 'object' && !this._inactive) {
          return !(this.spedizionieri.length > 0)
        }
      },
      canGoNext: function () {
        let obj = this.formTrasporto

        let flagDataArrivo = false
        if (this.conf.modoTrasp === '3') {
          if (obj.dataArrivo) {
            flagDataArrivo = true
          }
        } else if (this.conf.modoTrasp === '2') {
          flagDataArrivo = true
        }

        let ifTraspSpagna = false
        if (this.form.country === '3') {
          ifTraspSpagna = (
            (this.ifSpedizObblig ? this.formTrasporto.spedizioniere.codSpediz : this.formTrasporto.ragSocTrasp) && this.formTrasporto.indirTrasp &&
            this.formTrasporto.capTrasp && this.formTrasporto.localTrasp && this.formTrasporto.nomeAutista && this.formTrasporto.nPatente &&
            this.formTrasporto.paIvaTrasp
          )
        } else {
          ifTraspSpagna = true
        }

        // La località è un campo SEMPRE obbligatorio
        let ifLocalita = (this.formTrasporto.loc.codLoca)

        // se ifSpedizObblig = TRUE allora lo spedizioniere deve essere valorizzato obbligatoriamente
        let ifSpediz = this.ifSpedizObblig ? (this.formTrasporto.spedizioniere.codSpediz) : true

        return (obj.dataSpedizione && flagDataArrivo && ifTraspSpagna && ifLocalita && ifSpediz)
      }
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          this.$set(this, 'form', (sessionStorage.hasOwnProperty('WGR_form') ? (JSON.parse(sessionStorage.getItem('WGR_form'))) : (this.form)))
          this.$set(this, 'formTrasporto', JSON.parse(JSON.stringify(this.saved)))

          if (!this._inactive && this.formTrasporto.dataSpedizione) {
            this.getLocalita()
            this.getOrdNave()
            this.getSpedizionieri()
            if (this.formTrasporto.ROT_SLOT_RULES === 'Y' && this.formTrasporto.dataArrivo) {
              this.getSlots()
            }
          }
        })
      },
      avanti: function () {
        this.$set(this, 'loadingButton', true)
        let slotObj = null
        this.slots.forEach(slot => {
          if (slot.cod === this.formTrasporto.slot) {
            slotObj = slot
          }
        })
        let data = {
          codLang: this.codLang,
          country: this.form.country,
          codForn: this.form.fornitore.codForn,
          tipoForn: this.form.fornitore.tipForn,
          codSoc: this.form.stab.codSoc,
          codStab: this.form.stab.codStab,
          numConf: this.conf.numConf,
          numDdt: this.formTrasporto.numDdt,
          fir: this.formTrasporto.fir_1 + ' ' + this.formTrasporto.fir_2 + ' ' + this.formTrasporto.fir_3,
          fir_1: this.formTrasporto.fir_1,
          fir_2: this.formTrasporto.fir_2,
          fir_3: this.formTrasporto.fir_3,
          targaMot: this.formTrasporto.targaMotrice,
          targaRim: this.formTrasporto.targaRimorchio,
          numVagone: this.formTrasporto.numVagone,
          datSped: this.formTrasporto.dataSpedizione,
          datArrivo: this.formTrasporto.dataArrivo,
          codLocalita: this.formTrasporto.loc.codLoca,
          desLocalita: this.formTrasporto.loc.desLoca,
          poiSO: this.formTrasporto.loc.poiSO,
          poiPR: this.formTrasporto.loc.poiPR,
          codSubfor: this.formTrasporto.subFor.codSubfor ? this.formTrasporto.subFor.codSubfor : '',
          desSubfor: this.formTrasporto.subFor.desSubfor ? this.formTrasporto.subFor.desSubfor : '',
          codSpediz: (this.formTrasporto.UNI_TRASP_ROT !== 'Y' && this.formTrasporto.spedizioniere.codSpediz) ? this.formTrasporto.spedizioniere.codSpediz : '',
          desSpediz: this.formTrasporto.spedizioniere.desSpediz ? this.formTrasporto.spedizioniere.desSpediz : '',
          codTRS: (this.formTrasporto.UNI_TRASP_ROT === 'Y' && this.formTrasporto.spedizioniere.codTRS) ? this.formTrasporto.spedizioniere.codTRS : '',
          nomeAutista: this.formTrasporto.nomeAutista,
          modoTrasp: this.conf.modoTrasp,
          tmStr: slotObj ? slotObj.timeStr : '',
          tmEnd: slotObj ? slotObj.timeEnd : '',
          gate: '', // Sempre vuoto per ROT
          codTsl: slotObj ? slotObj.cod : '',
          channel: slotObj ? slotObj.channel : '',
          numBuono: this.formTrasporto.numBuono
        }
        this.$http.post('buonidiscarico/check', data)
          .then(response => {
            if (response.body.rc === 0) {
              if (response.body.msg && response.body.msg.length > 0) {
                this.$confirm(response.body.msg[0].msgTxt, this.$t('trasporto.attenzione').toUpperCase(), {
                  confirmButtonText: this.$t('trasporto.prosegui').toUpperCase(),
                  cancelButtonText: this.$t('trasporto.correggi ').toUpperCase(),
                  type: 'warning',
                  customClass: 'custom-confirm',
                  showClose: false,
                  showCancelButton: true,
                  closeOnClickModal: true
                })
                  .then(() => {
                    let formObj = JSON.parse(JSON.stringify(this.formTrasporto))
                    formObj.ifSpedizObblig = this.ifSpedizObblig
                    formObj.tmStr = slotObj ? slotObj.timeStr : ''
                    formObj.tmEnd = slotObj ? slotObj.timeEnd : ''
                    formObj.codTsl = slotObj ? slotObj.cod : ''
                    formObj.channel = slotObj ? slotObj.channel : ''
                    this.$set(this, 'loadingButton', false)
                    delete formObj.fir
                    this.$emit('avanti', 0, formObj)
                  })
                  .catch(() => {
                    this.$set(this, 'loadingButton', false)
                  })
              } else {
                let formObj = JSON.parse(JSON.stringify(this.formTrasporto))
                formObj.ifSpedizObblig = this.ifSpedizObblig
                formObj.tmStr = slotObj ? slotObj.timeStr : ''
                formObj.tmEnd = slotObj ? slotObj.timeEnd : ''
                formObj.codTsl = slotObj ? slotObj.cod : ''
                formObj.channel = slotObj ? slotObj.channel : ''
                this.$set(this, 'loadingButton', false)
                delete formObj.fir
                this.$emit('avanti', 0, formObj)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loadingButton', false)
            }
          })
      },
      dataFilterSpediz: function (val) {
        if (val) {
          this.spedizionieriFiltered = this.spedizionieri.filter((item) => {
            if (item.desSpediz.toUpperCase().startsWith(val.toUpperCase())) {
              return true
            }
          })
        } else {
          this.spedizionieriFiltered = this.spedizionieri
        }
      },
      dataFilterSubFor: function (val) {
        if (val) {
          this.subFornitoriFiltered = this.subFornitori.filter((item) => {
            if (item.desSubfor.toUpperCase().startsWith(val.toUpperCase())) {
              return true
            }
          })
        } else {
          this.subFornitoriFiltered = this.subFornitori
        }
      },
      dataFilterLocalita: function (val) {
        if (val) {
          this.localitaFiltered = this.localita.filter((item) => {
            if (item.desLoca.toUpperCase().startsWith(val.toUpperCase())) {
              return true
            }
          })
        } else {
          this.localitaFiltered = this.localita
        }
      },
      changeDataArrivo: function () {
        this.$set(this.formTrasporto, 'slot', '')
        this.$set(this, 'slots', [])
        if (this.formTrasporto.dataArrivo) {
          this.getSlots()
        }
      },
      getSlots: function () {
        this.$http.get('buonidiscarico/slots', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codSoc: this.form.stab.codSoc,
            codStab: this.form.stab.codStab,
            numConf: this.conf.numConf,
            numBuono: this.formTrasporto.numBuono,
            datArrivo: moment(this.formTrasporto.dataArrivo, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'slots', response.body.data)
            } else {
              this.$set(this, 'slots', [])
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getOrdNave: function () {
        this.$http.get('buonidiscarico/ordnave', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            numConf: this.conf.numConf,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'ordNave', response.body.data)
            } else {
              this.$set(this, 'ordNave', [])
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
          })
      },
      getLocalita: function () {
        this.$http.get('buonidiscarico/localita', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codSubfor: this.formTrasporto.subFor.codSubfor,
            numConf: this.conf.numConf,
            codSoc: this.form.stab.codSoc,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'localita', response.body.data)
              this.$set(this, 'localitaFiltered', response.body.data)
              this.getSubfornitori()
            } else {
              this.$set(this, 'localita', [])
              this.$set(this, 'localitaFiltered', [])
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
          })
      },
      getSubfornitori: function () {
        this.$http.get('buonidiscarico/subfornitori', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            numConf: this.conf.numConf,
            codLoca: this.formTrasporto.loc.codLoca,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'subFornitori', response.body.data)
              this.$set(this, 'subFornitoriFiltered', response.body.data)
            } else {
              this.$set(this, 'subFornitori', [])
              this.$set(this, 'subFornitoriFiltered', [])
              this.$set(this.formTrasporto, 'subFor', {})
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
          })
      },
      getSpedizionieri: function () {
        this.$http.get('buonidiscarico/spedizionieri', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            modoTrasp: this.conf.modoTrasp,
            numConf: this.conf.numConf,
            codSoc: this.form.stab.codSoc,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'spedizionieri', response.body.data)
              this.$set(this, 'spedizionieriFiltered', response.body.data)
            } else {
              this.$set(this, 'spedizionieri', [])
              this.$set(this, 'spedizionieriFiltered', [])
              if (!this.formTrasporto.spedizioniere.desSpediz) {
                this.$set(this.formTrasporto, 'spedizioniere', {})
              }
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
            if (response.body.attrib) {
              this.$set(this, 'ifSpedizObblig', (response.body.attrib.seObb && response.body.attrib.seObb === 'X'))
            } else {
              this.$set(this, 'ifSpedizObblig', false)
            }
          })
      },
      changeLocalita: function (val) {
        if (val === '') {
          this.$set(this.formTrasporto, 'loc', {codLoca: '', desLoca: '', poiSO: '', poiPR: ''})
        }
        this.$set(this.formTrasporto, 'subFor', {})
        // this.$set(this.formTrasporto, 'spedizioniere', {})
        this.getSubfornitori()
      },
      changeSubfor: function () {
        // this.$set(this.formTrasporto, 'spedizioniere', {})
        // this.getSpedizionieri()
      },
      getIntestatario: function () {
        this.$set(this.formTrasporto, 'targaMotrice', this.formTrasporto.targaMotrice.trim())
        if (this.formTrasporto.ifRifiuto === '1') {
          this.$http.get('buonidiscarico/intestatario', {
            params: {
              codLang: this.codLang,
              country: this.form.country,
              targa: this.formTrasporto.targaMotrice
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                this.$set(this, 'intestatario', response.body.attrib.intMezzo)
              } else {
                this.$set(this, 'intestatario', '')
              }
            })
        } else {
          this.$set(this, 'intestatario', '')
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .trasporto {
    margin-top: 60px;
    .dati-trasportatore {
      margin-top: 20px;
      .div-titolo {
        border-bottom: 1px solid @oroRiva;
        margin-bottom: 15px;
        .titolo {
          .set-font(@size: 14px, @color: @oroRiva, @family: 'os-semibolditalic');
          text-align: left;
          line-height: 22px;
          letter-spacing: 1px;
        }
      }

    }
    .riga {
      .my-label {
        .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
        text-align: right;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 10px;
      }
      .value-big {
        .set-font(@family: 'os-semibold', @color: #666, @size: 16px);
        line-height: 22px;
      }
      .value {
        .set-font(@family: 'os-semibold', @color: #666, @size: 16px);
        line-height: 23px;
      }
      .value-intestatario {
        .set-font(@family: 'os-regular', @color: #666, @size: 13px);
        line-height: 21px;
      }
      .custom-select-el {
        .el-input__inner {
          height: 22px !important;
          border: 1px solid #dcdfe6;
          padding: 0 5px;
        }
        .el-input__inner:hover {
          border: 1px solid @greenRiva;
        }
      }
      .custom-input {
        .el-input__inner {
          height: 22px !important;
          padding: 0 5px;
          border: 1px solid #dcdfe6;
        }
      }
      .custom-date-picker {
        .el-input__inner {
          height: 22px !important;
          padding-left: 30px !important;
          border: 1px solid #dcdfe6;
        }
        .el-input__inner:focus {
          border-color: @greenRiva;
        }
        .el-input__prefix {
          left: 0;
        }
      }
      .custom-date-picker-half {
        padding-left: 0 !important;
        .el-input__inner {
          padding-left: 24px !important;
          font-size: 13px;
          padding-right: 15px;
        }
        .el-input__prefix {
          left: 0;
          height: 22px !important;
          .el-input__icon::before {
            line-height: 22px !important;
          }
        }
        .el-input__suffix {
          right: 14px;
          height: 22px !important;
          .el-input__icon::before {
            line-height: 22px !important;
          }
        }
      }
      .custom-select-half {
        .el-input__inner {
          letter-spacing: 0;
        }
      }
    }
    .button {
      margin-top: 30px;
      margin-bottom: 20px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/Trasporto.vue